module.exports = __webpack_public_path__ + "static/media/P2.0c6195f8.png";